import React from "react";
import Drawer from "../../../drawer/Drawer";
import ManagePromoter from "./ManagePromoter";

const PromoterDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      size={"xl3"}
      title={
        <span className="tracking-tighter uppercase font-bold">
          Manage Promoter
        </span>
      }
      subtitle="View order details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-85px)] overflow-y-hidden scrollbar flex bg-gradient-to-tr from-[#f5faff] via-white to-[#fef6f9]"
    >
      <ManagePromoter getResponse={getResponse} data={data} />
    </Drawer>
  );
};

export default PromoterDrawer;
